module.exports = new Promise(function(resolve) {
    if (typeof window["oauthApp"] !== "undefined") return resolve(window["oauthApp"]);
    var resolved = false;
    function done(container) {
      if (resolved) return;
      resolved = true;
      resolve(container);
    }
    var timer = setTimeout(function() {
      console.warn("[MF] Remote oauthApp at __OCT_RUNTIME_REMOTE__ timed out after 3000ms");
      done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
    }, 3000);
    var script = document.createElement("script");
    var remoteUrl = "http://localhost:3001/remoteEntry.js";
    try {
      var configuration = JSON.parse(window.localStorage.getItem("configuration") || "{}");
      var configuredBase = configuration["oauthClientUrl"];
      if (configuredBase) {
        remoteUrl = String(configuredBase).replace(/\/+$/, "") + "/remoteEntry.js";
      } else {
        var parsedRemoteUrl = new URL(remoteUrl, window.location.href);
        if ((parsedRemoteUrl.hostname === "localhost" || parsedRemoteUrl.hostname === "127.0.0.1")
          && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
          parsedRemoteUrl.hostname = window.location.hostname;
        }
        remoteUrl = parsedRemoteUrl.toString();
      }
    } catch (error) {
      console.warn("[MF] Cannot resolve tenant remote oauthApp", error);
    }
    
    script.src = remoteUrl;
    script.async = true;
    script.onload = function() {
      clearTimeout(timer);
      if (window["oauthApp"]) {
        done(window["oauthApp"]);
      } else {
        console.warn("[MF] Remote oauthApp loaded but container not found");
        done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
      }
    };
    script.onerror = function() {
      clearTimeout(timer);
      console.warn("[MF] Remote oauthApp at __OCT_RUNTIME_REMOTE__ unreachable");
      done({ get: function() { return Promise.resolve(function() { return { __esModule: true, default: function() { return null; } }; }); }, init: function() {} });
    };
    document.head.appendChild(script);
  });